import "./featured-area-search.scss"
import util from '@/common/util';
import { params2linkHash } from '@/common/search-request';
import { mapState as rootMapState } from 'pinia';
import { mapState, mapActions } from '@/store/helpers';
import { usePageStore } from '@/store';
import getUseStore from './_store';
import {
    LISTING_SOURCE_MUTATION,
    LAYOUTOPTIONS_UPDATE_MUTATION
} from './_store/config';
import searchCommon from './_mixins/common';
import * as TYPES from '@/components/search-result/_store/types';
import global from '@/common/global';
import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData, conditionChange, processViewPattern, getRequestType } from './asyncData';
import { getQueryWithDecodeKey } from '@/clientEnv';
import { cmsConfigKeys } from "./_conf"

export default {
    mixins: [searchCommon],
    // asyncData: mapAsyncData(asyncData),
    asyncData: mapAsyncData(function(store) {
        store[LAYOUTOPTIONS_UPDATE_MUTATION](['mixed', 'map', 'normal']);
        return asyncData.call(this, store);
    }),
    _getUseStore: getUseStore,
    data: function() {
        const blockData = {
            listingSource: '',
            hideRedo: false, //  whether to hide  redo search on map
            hidePlot: false, //  whether to hide  plot icon
            hideMapArea: false,
            mode: 'grid',
            mobileMode: 'grid',
            showSearchBar: true,
            centerPoint: '',
            zoom: 12,
            property_gathering_amount: 10,
            presetFilters: [], //  in the module preset filter。 that is in cms middle preset Filter The value set in 
            presetFiltersV2: {},
            keywordsPlaceholder: '', //  I don't know where to set it ， possibly custom code 
            sortConfigs: null,
            hideBelow: false,
            scrollwheel: false,
            mapDrawTip: null,
            showSchool: false,
            hideSearchChoose: false
        };
        return {
            searchModuleType: '',
            mapSearchText: null,
            ...blockData,
            height: '',
            watchLayout: false,
        };
    },
    provide() {
        return {
            scrollwheel: this.scrollwheel,
            id: this.id,
            getFooterData: this.getFooterData,
            scrollTop: force => {
                let el = this.$el;
                if (
                    force ||
                    window.innerHeight + global.scroll('fetch') - el.offsetTop <
                    400
                ) {
                    util.scrollIntoView(el, true, 0);
                }
            },
            resetHeight: this.resetHeight,
            hideMapArea: this.hideMapArea,
            conditionChange: this.conditionChange,
            searchModuleType: this.searchModuleType,
            onlyShowHouses: this.onlyShowHouses
        };
    },
    watch: {
        computedMode: {
            // immediate: true,
            handler: function() {
                // this.initMode();
                this.processViewPattern({});
            }
        },
        // isMobileSize() {
        //     this.initMode();
        // },
        mapCondition: {
            deep: true,
            handler: function(newVal, oldVal) {
                if (
                    newVal.mapSearch ||
                    oldVal.mapSearch ||
                    newVal.mapPath ^ oldVal.mapPath
                ) {
                    this.resetPage();
                }
                if (!util.isObjectSame(newVal, oldVal, false)) {
                    const type = this.getRequestType();
                    if (this.blockName !== 'md-search-big-map') {
                        if (
                            newVal.mapPath !== oldVal.mapPath ||
                            newVal.mapRadius !== oldVal.mapRadius
                        ) {
                            type.listOnly = true;
                        } else {
                            type.listOnly = false;
                        }
    
                        if (
                            newVal.mapSearch !== oldVal.mapSearch ||
                            newVal.mapSearch
                        ) {
                            type.listOnly = true;
                        }
                    }
                    this.$refs.listingSearch &&
                        this.$refs.listingSearch.$emit('conditionChange', {
                            init: !this.mapInited,
                            type,
                            oldVal: oldVal,
                            value: newVal,
                            condition: this.searchParamsWithMap
                        });
                }
            }
        },
        layout: {
            handler: function(newVal, oldVal) {
                // 只要不是从normal切到地图, 或者切到了移动端地图, 就要更新数据
                if (!(newVal === 'map' && oldVal === 'normal') || (newVal === 'map' && this.isMobileSize)) {
                    this.searchDataAction({
                        ...this.getRequestType(),
                        noTimeline: true,
                        isMobile: this.isMobile
                    });
                    if (newVal === 'map') {
                        // util.scrollIntoView(this.$el, true);
                        this.$nextTick(() => {
                            this.resetHeight();
                        });
                    }
                }
            }
        },
        centerPoint: {
            handler: function(val) {
                this.setCenterPoint(val)
            }
        }
    },
    computed: {
        ...rootMapState(usePageStore, {
            page: store => store.page || {}
        }),
        ...rootMapState(usePageStore, ['forCMS', 'soldListingFlag']),
        ...mapState({
            layout: store => store.layout,
            mapCondition: store => store.mapCondition,
            mapInited: store => store.mapInited,
            listingSourceReady: store => store.listingSourceReady,
            gridOrListType: store => store.gridOrListType,
            keywords: store => store.keywords
        }),
        ...mapState([
            'allConditions',
            'searchParamsWithMap',
            'isBigMap',
            'isGridOrList',
            'layoutState'
        ]),
        isMobile() {
            return this.platform.isMobile;
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        isEmbed() {
            return window.parent && window.parent !== window;
        },
        dataToSearchBar() {
            return {
                presetFilters: this.presetFilters,
                presetFiltersV2: this.presetFiltersV2
            };
        },
        dataToSearchResult() {
            return {
                hideRedo: this.hideRedo, //  whether to hide  redo search on map
                hidePlot: this.hidePlot //  whether to hide  plot icon
            };
        },
        computedMode() {
            if (this.isMobileSize) {
                return this.mobileMode;
            } else {
                return this.mode;
            }
        },
        style() {
            if (this.layout === 'map' || this.layout === 'mixed') {
                return this.isMobile
                    ? { 'min-height': this.height }
                    : { height: this.height };
            } else {
                return {};
            }
        }
    },
    methods: {
        ...mapActions({
            updateSearchParams: TYPES.UPDATE_SEARCH_PARAMS,
            sortUpdateMutation: TYPES.SORT_UPDATE_MUTATION,
            setSortConfigsMutation: TYPES.SET_SORT_CONFIGS,
            pageChangeMutation: TYPES.PAGE_CHANGE_MUTATION,
            listingSourceMutation: LISTING_SOURCE_MUTATION,
            mapChangeMutation: TYPES.MAP_CHANGE_MUTATION,
            prevViewPatternMutation: TYPES.PREV_VIEW_PATTERN_MUTATION,
            setCenterPoint: TYPES.SET_CENTER_POINT,
            setZoom: TYPES.SET_ZOOM,
            propertyGatheringAmount: TYPES.PROPERTY_GATHERING_AMOUNT,
            searchDataAction: TYPES.SEARCH_DATA_ACTION,
            updateUrl: TYPES.UPDATE_URL
        }),
        getFooterData() {
            return this.footerData;
        },
        resetPage() {
            this.pageChangeMutation({
                page: 1
            });
        },
        getRequestType: mapAsyncData(getRequestType),
        _conditionChange: mapAsyncData(conditionChange),
        async conditionChange(params) {
            await this._conditionChange(params);
            if (!params.init) {
                this.updateUrl();
            }
            // if (!this.watchLayout && params.kee) {
            //     this.watchLayout = true;
            //     this.setWatchLayout();
            // }
            this.blockOb?.dispatch('conditionChange', params);
        },
        processViewPattern: mapAsyncData(processViewPattern),
        watchListingSource() {
            this.listingSourceMutation(this.listingSource);
            this.isEmbed &&
                !this.forCMS &&
                this.searchDataAction({
                    ...this.getRequestType(),
                    noTimeline: true,
                    isMobile: this.isMobile
                });
        },
        watchSortConfigs() {
            this.setSortConfigs();
        },
        watchZoom() {
            this.mapChangeMutation({
                zoom: this.zoom
            });
            this.setZoom(this.zoom);
        },
        watchPropertyGatheringAmount() {
            this.mapChangeMutation({
                threshold: this.property_gathering_amount
            });
            this.propertyGatheringAmount(this.property_gathering_amount);
        },
        watchCenterPoint() {
            this.setCenterPoint(this.centerPoint);
        },
        // cms  configuration 
        setWatchers() {
            if (this.isEmbed && !this.forCMS) {
                cmsConfigKeys.forEach(key => {
                    const fnName = `watch${key
                        .replace(/_(\S)/g, (match, p1) => {
                            return p1.toUpperCase();
                        })
                        .replace(/^(\S)/g, (match, p1) => p1.toUpperCase())}`;

                    this.$watch(key, this[fnName]);
                });
            }
        },
        resetHeight() {
            this.height =
                (this.isMobile
                    ? this.calcMobileHeight()
                    : this.calcPCHeight()) + 'px';
        },
        calcMobileHeight() {
            const headerEl = document.querySelector('.page-content>.md-header');
            const headerHeight = (headerEl && headerEl.offsetHeight) || 0;
            const screenHeight = window.innerHeight;
            const remainingHeight = screenHeight - headerHeight;
            if (
                this.hideBelow ||
                this.$root.moduleData.filter(
                    v => v.name != 'md-header' && v.name != 'md-footer'
                ).length == 1
            ) {
                return Math.floor(remainingHeight);
            }
            // remove md-header and md-search outside ， Overall height of other modules 
            const otherModuleTotalHeight =
                document.querySelector('.page-content').offsetHeight -
                ((this.$el && this.$el.offsetHeight) || 0) -
                headerHeight;
            if (otherModuleTotalHeight > remainingHeight * 0.2) {
                return Math.floor(remainingHeight * 0.8);
            }
            return Math.floor(remainingHeight - otherModuleTotalHeight);
        },
        calcPCHeight() {
            const headerEl = document.querySelector('.page-content>.md-header');
            const remainingHeight =
                window.innerHeight - ((headerEl && headerEl.offsetHeight) || 0);
            return Math.max(Math.floor(remainingHeight), 500);
        },
        setSortConfigs() {
            if (!this.sortConfigs || this.sortConfigs.length === 0) {
                return;
            }
            this.setSortConfigsMutation(this.sortConfigs);
            let _sortConfigs = this.sortConfigs.filter(
                sort => sort.show !== false
            );
            this.sortUpdateMutation(
                _sortConfigs.length === 0 ? 'RELEVANCE' : _sortConfigs[0].value
            );
        }
    },
    // created() {
    //     this.setSearchModuleType(this.searchModuleType);

    // },
    mounted() {
        // this.resetHeight();
        if (!this.isMobile) {
            window.addEventListener('resize', this.resetHeight);
        }
        this.setWatchers()
    },
    beforeDestory() {
        window.removeEventListener('resize', this.resetHeight);
    },
    async afterAsyncData() {
        let query = getQueryWithDecodeKey(this.page);
        query = await params2linkHash.call(this, query, this.page)
        let { search, pathname } = window.location;
        // hashLink first entry link unchanged
        let hashLinkRegExp =
            /searchId=[0-9a-zA-Z]{1,6}_[0-9a-zA-Z]{1,6}/;
        if (
            Object.keys(query).length > 0 &&
            search &&
            !hashLinkRegExp.test(search)
        ) {
            let url = util.setQueryField(query, pathname);
            window.history.replaceState({}, null, url);
        }
    }
};
